import { useSelector } from 'react-redux';
import { isEmpty } from 'lodash-es';

import dayjs from '@/services/tools/dayjs';
import { getTimeInUnits } from '@/services/tools/getTimeInUnits';
import { TimeUnitsEnum } from '@/services/dictionaries/TimeUnits';
import { getCampainCreatorStore } from '@/store/campaignCreator/actions';

export const useGetScheduledInfo = () => {
    const { isLoading, campaign } = useSelector(getCampainCreatorStore);

    const isDataLoaded = !isLoading && !isEmpty(campaign);
    const isEdit = isDataLoaded && !isEmpty(campaign.TriggerOptions.DateToSendOn);
    const timeObj = getTimeInUnits(campaign.TriggerOptions?.SendEveryXMinutes) || null;

    const isOneTime = campaign.TriggerOptions?.SendXTimes === 1;
    const triggerValue = isEdit ? timeObj.value : 1;
    const triggerUnit = isEdit ? timeObj.unit : TimeUnitsEnum.Days;
    const dateToSend = campaign.TriggerOptions.DateToSendOn;

    const sendEveryXTimes = isEdit ? dayjs(dateToSend).utc(true).local() : dayjs().add(1, 'hour');

    return { isOneTime, sendEveryXTimes, triggerValue, triggerUnit };
};
